import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSanitize from 'rehype-sanitize';

/**
 * Safe Markdown renderer.
 * - Supports GitHub-flavored markdown (tables, strikethrough, lists).
 * - Sanitizes output (no raw HTML rendering).
 */
export default function Markdown({ children, className = '' }) {
  if (!children) return null;

  return (
    <div className={className}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSanitize]}>
        {String(children)}
      </ReactMarkdown>
    </div>
  );
}


